import { IconBase, IconComponent } from './BaseIcon';

export const Mail: IconComponent = (props) => (
  <IconBase {...props}>
    <path d="M2 6v17.4a2.93 2.93 0 0 0 2.9 2.95h22.18A2.93 2.93 0 0 0 30 23.42V6zm23.79 2L16 14.79 6.18 8zm1.28 16.33H4.9a.93.93 0 0 1-.9-.91V8.92l12 8.29 12-8.29v14.5a.93.93 0 0 1-.92.93z" />
  </IconBase>
);
